<template>
    <div class='info-container'>
        <img class="logo" src="/images/logos/majestic-logo-round.png" />
          <div class='footer-column-links'>
           <!-- <div>Majestic House,</div> -->
           <div>The Belfry</div>
           <div>Colonial Way</div>
           <div>Watford WD24 4WH</div>
           <div><a class='mail-to-link' href="tel::020 7697 8000">020 7697 8000</a></div>
           <div><a class='mail-to-link' href='mailto:commercialsupport@majestic.co.uk'>commercialsupport@majestic.co.uk</a></div>
            <div>
                <a href='https://www.linkedin.com/company/majestic-wine/posts/?feedView=all'><img class='linked-in-logo' src="/images/footer/linkedin.webp"/></a>
            </div>

           <!-- <div> United Kingdom</div> -->
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        onClickLink(page) {
            this.$router.push(`/${page}`);
        }
    }
}
</script>


<style lang="scss" scoped>

.info-container{
    font-size: 1.1rem;
}
.logo{
    width: 100px;
    padding-left: 16px;
    @media(max-width: 768px){
        padding-left: 0px;
    }
}

.address-container{
    margin-top: 24px;
}

.footer-column-links{
    padding-left: 16px;
    @media(max-width: 768px){
        padding-left: 0px;
    }
}

.mail-to-link{
    color: var(--maj-slate);
}

.linked-in-logo{
    width: 30px;
    height: 30px;
    margin-top: 12px;
}
</style>